import React, { useEffect, useState } from "react";
import totalSchoolsIcon from "../Assets/Images/Dashboard/Total_schools_icon.svg";
import totalVideosIcon from "../Assets/Images/Dashboard/Total_videos_icon.svg";
import videoProgressIcon from "../Assets/Images/Dashboard/video_progress_icon.svg";
import { Pie, PieChart, Cell } from "recharts";
import { VIDEO_WATCHING_PROGRESS } from "../Component/AllApi";

const VideoWatchingProgress = () => {
  // const [isLoading,setIsLoading] = useState(false);
  // const data = [
  //   { name: "Category A", value: 80 },
  //   { name: "Remaining", value: 20 },
  // ];

  const [apiData, setApiData] = useState([]);
  
  const userRole = localStorage.getItem("user_role");

  // eslint-disable

  const token = localStorage.getItem("authToken");
  // setApiData([]);
  useEffect(() => {
    const fetchData = async () => {
      // console.log('token: ',token)
      try {
        let response = await fetch(VIDEO_WATCHING_PROGRESS, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
          },
        });
        if (response.ok) {
          const responseData = await response.json();
          // console.log("data: ", responseData);
          setApiData(responseData);
          // setProgressData(data);
        }
      } catch (err) {
        console.error("Error occured ", err);
      }
    };

    fetchData();
  }, [token]);
  const data = [
    { name: "progress", value: apiData?.average_progress },
    { name: "remaining", value: 100 - apiData?.average_progress },
  ];

  return (
    <>
      <section className="videoProgress">
        <div className="row mb-0">
          <div className="col-lg-6">
            <div className="card progress_card">
              <div className="row">
                <div className="col-lg-7">
                  <img src={videoProgressIcon} alt="videoProgressIcon" />
                  <p className="progressTitle mt-2">Video Watching Progress</p>
                  <p className="allTimeTitle">All Time</p>
                </div>
                <div className="col-lg-5">
                  <PieChart width={200} height={120}>
                    <Pie
                      data={data}
                      dataKey="value"
                      nameKey="name"
                      cx="40%"
                      cy="50%"
                      innerRadius={50}
                      outerRadius={60}
                      fill="#4991BA"
                      stroke="none"
                      startAngle={90}
                      endAngle={-270}
                    >
                      {data.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={index === 0 ? "#EDB552" : "#4991BA"}
                        />
                      ))}
                    </Pie>
                    <text
                      x="40%"
                      y="50%"
                      textAnchor="middle"
                      dominantBaseline="middle"
                      fill="#fff"
                      fontSize={20}
                    >
                      {apiData?.average_progress
                        ? parseFloat(apiData?.average_progress).toFixed(2)
                        : 0}
                      %{/* {Math.round(apiData?.average_progress)} % */}
                      {/* {apiData?.average_progress}% */}
                    </text>
                  </PieChart>
                </div>
              </div>
              <div className="totalWatchTimeCard mt-3">
                <span>
                  Total watch time:{" "}
                  {apiData?.average_watch_time_per_trainer_per_video}
                </span>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row">
              <div className="col">
                <div className="card ps-5" style={{boxShadow: "0px 4px 34px 0px #b6c1c757"}}>
                  <div className="d-flex">
                    <img src={totalSchoolsIcon} alt="totalSchoolsIcon" />
                    <p className="totalNo ms-4 my-auto ">
                      {apiData?.totalSchools}
                    </p>
                  </div>
                  <div className="main_title mt-4">
                    {" "}
                    {`Total ${
                      userRole === "Principal" ? "Trainers" : "Schools"
                    }`}
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card ps-5" style={{boxShadow: "0px 4px 34px 0px #b6c1c757"}}>
                  <div className="d-flex">
                    <img src={totalVideosIcon} alt="totalSchoolsIcon" />
                    <p className="totalNo ms-4 my-auto">
                      {apiData?.totalVideos}
                    </p>
                  </div>
                  <div className="main_title mt-4">Total Videos</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VideoWatchingProgress;
